module.exports = __webpack_public_path__ + "static/media/active_passive_background.cf39d395.svg";